var SPACE = {
    PRESET_NAME: {
        MAX_LENGTH: 20,
    },
    RESERVATION: {
        MIN_STEP: 10,
    },
};
export default SPACE;
